import { sessionStorage } from 'dibs-browser-storage';

import { FAVORITES_SESSION_STORAGE_KEYS } from '../constants';

function wasFavoritesNudgeDisplayed(): boolean {
    return !!sessionStorage.getItem(FAVORITES_SESSION_STORAGE_KEYS.FAVORITES_NUDGE_DISPLAYED);
}

export { wasFavoritesNudgeDisplayed };
